import React from "react";
import icon_info_red from "bodycodi/cmap/app/svg/icon_info_red.svg";

const MemberEmpty = () => {
  return (
    <div className="member-empty-wrap">
      <img src={icon_info_red} />
      센터에서 삭제된 회원으로
      <br />
      상세한 회원정보는 볼 수 없어요.
    </div>
  );
};

export default MemberEmpty;
